module.exports = __webpack_public_path__ + "img/wiewiory.111e0054.jpg";